import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { NbDialogService, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MessageListPrompComponent } from '../modal-overlays/dialog/message-list-promp/message-list-promp.component';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { TransactionResult } from 'app/@core/data/transaction-result';
import { environment } from 'environments/environment';
import { AuthService } from '../../../@core/services/auth.service';
import { MENU_ITEMS } from '../../../pages/pages-menu';
import { ChangePasswordDialogComponent } from '../../../pages/edyfica/modal-overlays/dialog/change-password/change-password.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  customerPresentation = environment.customerPresentation;
  languages : Array<any> = [];
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  appName: string = environment.appName;


  themeMenu = [
    { title: 'Tema Claro' },
    { title: 'Tema Oscuro' }
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Salir', link: '' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private dialogService: NbDialogService,
    private localStorage: LocalStorage,
    public translate : TranslateService,
    private authService: AuthService  ) {
  }

  private messageList: TransactionResult<any>[] = null;

  ngOnInit() {
    this.appName = this.authService.user.clientName + " - " + this.authService.user.siteName;

    this.languages.push({
        id: 1,
        title: 'Español',
        flag: 'es',
        applicationId: 0
    });
    this.languages.push({
      id: 1,
      title: 'English',
      flag: 'en',
      applicationId: 0
    });
    this.currentTheme = this.themeService.currentTheme;

    if (this.authService.isAuthenticated())
      this.user = this.authService.user;

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick().subscribe((event) => {
      this.onItemSelection(event.item.title);
    });
  }


  openWithEscClose() {
    this.dialogService.open(MessageListPrompComponent)
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  onItemSelection(title) {
    if (title === 'Salir') {
      let menu = MENU_ITEMS;
      menu.forEach(item => {
        if (item.title != "Inicio") {
          item.hidden = true;

          if (item.children != null && item.children != undefined) {
            item.children.forEach(child => { child.hidden = true; });
          }
        }
      });
      this.authService.logAuth(this.authService.user.clientCode);
    } else if (title === 'Cambiar Contraseña') {
      this.dialogService.open(ChangePasswordDialogComponent);
    }
    if(title === 'Español'){ this.setLanguages('es'); }
    if(title === 'English'){ this.setLanguages('en'); }
    if(title === 'Tema Claro') { this.changeTheme('default'); }
    if(title === 'Tema Oscuro') { this.changeTheme('dark'); }
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  setLanguages(lan : string){
    this.translate.setDefaultLang(lan);
    this.translate.use(lan);
  }
}
